export const STORAGE_NAME = {
  USER_LOGIN: 'USER_LOGIN',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  EXPIRES_AT: 'EXPIRES_AT',
  PKCE_CODE_VERIFIER: 'PKCE_CODE_VERIFIER',
  ID_TOKEN: 'ID_TOKEN'
};
